<template>
  <v-dialog v-model="modal" max-width="700">
    <v-form ref="form" :readonly="working" @submit.stop.prevent>
      <v-card>
        <v-card-title> Modifier un usager</v-card-title>
        <v-card-text>
          <p>
            Vous pouvez modifier la fonction ou les droits d'un
            usager dans cette association.
          </p>
          <v-text-field
            dense
            filled
            label="Fonction"
            v-model="fonction"
            :rules="[serverRule('fonction')]"
            data-testid="fonction"
          />
          <v-checkbox
            dense
            label="Droit de gestion"
            v-model="gestion"
            :rules="[serverRule('gestion')]"
            data-testid="droit-gestion"
          />
          <p class="accent-block">
              Permet de gérer les utilisateurs, notamment en inviter de nouveaux.
          </p>
          <v-checkbox
            dense
            label="Droit de dépôt"
            v-model="depot"
            :rules="[serverRule('depot')]"
            data-testid="droit-depot"
          />
          <p class="accent-block">
            Permet de déposer des requêtes au nom de l'association.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-btn data-testid="valider-modifier-usager" :loading="working" @click="confirme" color="primary"> Valider </v-btn>
          <v-btn data-testid="annuler-modifier-usager" :disabled="working" @click="ferme">Annuler</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import makeRemoteWorker from "@/mixins/makeRemoteWorker";
import makeRules from "@/mixins/makeRules";
import { associationService } from "@/services";
export default {
  mixins: [makeRules({ inject: false }), makeRemoteWorker({ provide: false })],
  data() {
    return {
      modal: false,
      email: null,
      fonction: null,
      gestion: false,
      depot: false,
      association: null,
    };
  },
  methods: {
    ouvre(association, usager, callback) {
      this.callback = callback;
      this.association = association;
      this.email = usager.email;
      this.gestion = usager.gestion;
      this.depot = usager.depot;
      this.fonction = usager.fonction;
      this.modal = true;
    },
    ferme() {
      this.modal = false;
    },
    confirme() {
      this.doWork({
        forms: [this.$refs.form],
        work() {
          return associationService.modificationUsager(
            this.association,
            this.email,
            this.fonction,
            this.gestion,
            this.depot,
          );
        },
        callback(response) {
          this.ferme();
          this.callback(
            { fonction: this.fonction, gestion: this.gestion, depot: this.depot },
            response
          );
        },
        successText: "L'utilisateur a été modifié.",
        errorText: "Erreur durant la modification de l'utilisateur.",
      });
    },
  },
};
</script>
